import "../css/OpeningPrices.css";

import { useNavigate } from "react-router-dom";


export default function OpeningPrices() {
  const navigate = useNavigate();
  return (
    <main className="opening-page">

      <section className="hero-section">
        <h1>Åbningstider & Priser</h1>
        <p>
          Her kan du se vores åbningstider, medlemskaber og priser.
        </p>
      </section>

      <section className="opening-hours">
        <h2>Åbningstider</h2>

        <div className="hours-card">
          <div className="hour-row">
            <span>Mandag</span>
            <span>Lukket</span>
          </div>

          <div className="hour-row">
            <span>Tirsdag</span>
            <span>Lukket</span>
          </div>

          <div className="hour-row">
            <span>Onsdag</span>
            <span>Lukket</span>
          </div>

          <div className="hour-row">
            <span>Torsdag</span>
            <span>Lukket</span>
          </div>

          <div className="hour-row">
            <span>Fredag</span>
            <span>Lukket</span>
          </div>

          <div className="hour-row">
            <span>Lørdag</span>
            <span>Lukket</span>
          </div>

          <div className="hour-row">
            <span>Søndag</span>
            <span>16:00 - 21:00</span>
          </div>
        </div>
      </section>

      <section className="pricing-section">
        <h2>Priser</h2>

        <div className="pricing-grid">
          <div className="price-card premium">
            <h3>Medlem kontingent</h3>
            <p className="price">1500 kr</p>
            <span>Per 6 måned</span>

            <ul>
             <li>Professionel esports træner</li>
             <li>Fast holdtræning med fokus på udvikling</li>
             <li>Replay-gennemgang og individuel feedback</li>
             <li>Adgang til Discord community og Aktiviteter</li>
             <li>Mulighed for deltagelse i turneringer</li>
             <li>Mulighed for at deltage i turneringer</li>
             <li>Styrk teamwork, kommunikation og spilforståelse</li>
             <li>Mulighed for bootcamp og lan</li>
             <li>Event og fælles aktiviteter i lokalerne</li>
            </ul>

            <button onClick={() => navigate("/signup-academy")}>
            Tilmeld
            </button>
          </div>

        </div>
      </section>

    </main>
  );
}